  <template>
    <div class="codes-actions">
     <a v-if="rowData.status == 0" v-bind:href="'/codes/'+ rowData.id + '/edit'"><button class="btn btn-primary"><i class="fas fa-paper-plane"></i></button></a>
     <button class="btn btn-danger delete" v-if="rowData.status == 0" v-confirm="{ok: dialog => deleteCode(dialog, rowData.id),  okText: 'Verwijderen', cancelText : 'Annuleren',  cancel: doNothing, message: 'Weet u zeker dat u deze gebruikt wilt verwijderen?'}"><i class="fas fa-times"></i></button>
    </div>
  </template>

  <script>
  export default {
    props: {
      rowData: {
        type: Object,
        required: true
      },
      rowIndex: {
        type: Number
      }
    }, 
    methods: {
      deleteCode: function(dialog, rowID) {
      $.ajax({
        type: 'DELETE',
        url: '/codes/' + rowID,
        dataType: 'json',
        headers: { 'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content') },
        data: {id:rowID},

        success: function (data) {
          location.reload();        
        },
        error: function (data) {
          alert(" Fout: U heeft wellicht geen rechten om de code te verwijderen." );
        }
      });
      },
      doNothing: function() {
        // Do nothing or some other stuffs
      }
    }
     
    
    
  }
  </script>

  <style>
.dg-btn--ok {
    color: #fff;
    background-color: #c82333;
    border-color: #bd2130;
 }
 
 .dg-btn--cancel {
  background: #818181;
  border-color:#818181;
  color:#fff;
 }

    
    
    
    
  </style>
